export default "__VITE_ASSET__CvWzFBAW__"